/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Downloads_Dropdown_Macos_IntelInputs */

const en_downloads_dropdown_macos_intel = /** @type {(inputs: Downloads_Dropdown_Macos_IntelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`macOS (Intel)`)
};

const es_downloads_dropdown_macos_intel = /** @type {(inputs: Downloads_Dropdown_Macos_IntelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`macOS (Intel)`)
};

/**
* | output |
* | --- |
* | "macOS (Intel)" |
*
* @param {Downloads_Dropdown_Macos_IntelInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const downloads_dropdown_macos_intel = /** @type {((inputs?: Downloads_Dropdown_Macos_IntelInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Downloads_Dropdown_Macos_IntelInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_downloads_dropdown_macos_intel(inputs)
	return en_downloads_dropdown_macos_intel(inputs)
});